import { render, staticRenderFns } from "./LichSuDichVuAmThucList.vue?vue&type=template&id=6fe925b9"
import script from "./LichSuDichVuAmThucList.vue?vue&type=script&lang=js"
export * from "./LichSuDichVuAmThucList.vue?vue&type=script&lang=js"
import style0 from "./LichSuDichVuAmThucList.vue?vue&type=style&index=0&id=6fe925b9&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports